import { ESRI, GOOGLE } from '@rsos/constants/mapProviders';
import exportToGlobalNamespace from '@rsos/utils/exportToGlobalNamespace';
import { getRSOSMap } from '@rsos/utils/rsosGlobal';
import { getGoogleMapViewState } from './getGoogleMapViewState';
import type { MapViewState } from './mapViewState.types';

/**
 * Capture the current map view state to `window.__RSOS.mapViewState`, which the
 * map transition hooks read to preserve position across a provider switch.
 * Must stay synchronous: callers dispatch the provider change and then call
 * this, and the transition hooks read the global in that same tick.
 */
export const exportMapViewState = (esriBasemap = ''): MapViewState | null => {
  const rsosMap = getRSOSMap();

  let viewState: MapViewState | null = null;

  if (rsosMap?.mapProvider === ESRI) {
    viewState = rsosMap.getViewState?.(esriBasemap) ?? null;
  } else if (rsosMap?.mapProvider === GOOGLE) {
    viewState = getGoogleMapViewState(esriBasemap);
  }

  exportToGlobalNamespace('mapViewState', { ...viewState });

  return viewState;
};
